import React from 'react';
import './Hero2.css';
import leftimage from "../assets/Codingleftimg.png"
import rightimage from "../assets/Codingrightimg.png"


const Hero2  = ({
  titlePart1,
  titlePart2,
  description,
  buttonText,
  leftImage,
  rightImage
}) => {
  
  return (
    <div className="hero-section">
      <div className="hero-container">
        <h1 className="hero-title">
          {titlePart1} <br />
          <span>{titlePart2}</span>
        </h1>
        <p className="hero-description">{description}</p>
        <button className="hero-button">{buttonText}</button>
        <div className="hero-images">
          <img src={leftImage} alt="Left Character" className="hero-left-image" />
          <img src={rightImage} alt="Right Character" className="hero-right-image" />
        </div>
      </div>
    </div>
  );
};

export default Hero2;